import { useAlgoliaAppContext } from './useAlgoliaAppContext';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
const components = document.querySelectorAll('search-form-component');
export const useSearchForm = () => {
    const { pagePath } = useAlgoliaAppContext();
    const navigate = useNavigate();
    const handler = (event) => {
        navigate({
            pathname: '/search',
            search: event.detail.length > 0 ? `?q=${event.detail}` : undefined
        });
    };
    useEffect(() => {
        if (pagePath !== 'search' || components.length < 1)
            return;
        components.forEach(component => {
            component.addEventListener('newSearch', handler);
        });
        return () => {
            components.forEach(component => {
                component.removeEventListener('newSearch', handler);
            });
        };
    }, []);
};
